import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface UnicoAuthState {
  token?: string;
  update: (token: string) => void;
  clearSession: () => void;
}

const initialValues = {
  token: undefined
};

export const useUnicoAuthStore = create<UnicoAuthState>()(
  persist(
    (set) => ({
      ...initialValues,
      update: (token: string) => {
        return set({ token });
      },
      clearSession: () => set(initialValues)
    }),
    {
      name: "UnicoAuthStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);

export function clearUnicoSession(): void {
  useUnicoAuthStore.getState().clearSession();
}

export default useUnicoAuthStore;
